"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var SERVERS = {
    "1": "Shared server #1",
    "2": "Playground server #1",
    "3": "Shared server #2"
};
var IntegrationStatsList = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _m = (0, react_1.useState)(undefined), stats = _m[0], setStats = _m[1];
    (0, react_1.useEffect)(function () {
        if (props.jobState) {
            var loadIntegrationStats_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
                var statsData, sumStats, tmp, script, key, ts, key, ts, avg, latestDay;
                var _a, _b, _c, _d, _e, _f;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0: return [4 /*yield*/, props.jobState.getStatistics()];
                        case 1:
                            statsData = _g.sent();
                            sumStats = {
                                hour: [],
                                day: [],
                                month: [],
                                year: [],
                            };
                            tmp = {};
                            for (script in statsData) {
                                for (key in statsData[script]) {
                                    for (ts in statsData[script][key]) {
                                        if (!tmp[key]) {
                                            tmp[key] = {};
                                        }
                                        if (!tmp[key][ts]) {
                                            tmp[key][ts] = { ts: ts, count: 0, failed: 0, success: 0, time: 0, browser: 0 };
                                        }
                                        tmp[key][ts].count += (_a = statsData[script][key][ts].count) !== null && _a !== void 0 ? _a : 0;
                                        tmp[key][ts].failed += (_b = statsData[script][key][ts].failed) !== null && _b !== void 0 ? _b : 0;
                                        tmp[key][ts].success += (_c = statsData[script][key][ts].success) !== null && _c !== void 0 ? _c : 0;
                                        tmp[key][ts].time += (_d = statsData[script][key][ts].time) !== null && _d !== void 0 ? _d : 0;
                                        tmp[key][ts].browser += (_e = statsData[script][key][ts].browser) !== null && _e !== void 0 ? _e : 0;
                                    }
                                }
                            }
                            for (key in tmp) {
                                for (ts in tmp[key]) {
                                    sumStats[key].push(tmp[key][ts]);
                                }
                                sumStats[key].sort(function (a, b) { return a.ts > b.ts ? 1 : (a.ts < b.ts ? -1 : 0); });
                            }
                            // find and set latest day's statistics.
                            if (sumStats.day.length > 0) {
                                avg = sumStats.day[0].time > 0 && sumStats.day[0].count > 0
                                    ? sumStats.day[0].time / sumStats.day[0].count
                                    : 0;
                                latestDay = {
                                    runs: (_f = sumStats.day[0].count) !== null && _f !== void 0 ? _f : 0,
                                    time: {
                                        h: Math.floor(sumStats.day[0].time / 3600000),
                                        m: Math.floor((sumStats.day[0].time % 3600000) / 60000),
                                        s: Math.floor((sumStats.day[0].time % 60000) / 1000),
                                        avg_m: Math.floor(avg / 60000),
                                        avg_s: Math.floor((avg % 60000) / 1000),
                                    },
                                    browser: {
                                        h: Math.floor(sumStats.day[0].browser / 3600000),
                                        m: Math.floor((sumStats.day[0].browser % 3600000) / 60000),
                                        s: Math.floor((sumStats.day[0].browser % 60000) / 1000),
                                    }
                                };
                                setStats(latestDay);
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
            props.jobState.onStatsLoadedChanged(function () {
                loadIntegrationStats_1();
            });
            loadIntegrationStats_1();
        }
    }, [props.jobState]);
    return (react_1.default.createElement(react_1.default.Fragment, null, props.integrationTemplate
        ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
                t("Statistics"),
                " ",
                react_1.default.createElement("sup", null, "(experimental)")),
            react_1.default.createElement("ul", null,
                react_1.default.createElement("li", null,
                    react_1.default.createElement("div", null, t("Server")),
                    react_1.default.createElement("ul", null,
                        react_1.default.createElement("li", null, (_b = SERVERS[(_a = props.integration) === null || _a === void 0 ? void 0 : _a.server_id]) !== null && _b !== void 0 ? _b : "no server"))),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("div", null, t("Processing time")),
                    react_1.default.createElement("ul", null,
                        react_1.default.createElement("li", null, (_c = stats === null || stats === void 0 ? void 0 : stats.time.h) !== null && _c !== void 0 ? _c : 0,
                            react_1.default.createElement("small", null, "h"),
                            " ",
                            String((_d = stats === null || stats === void 0 ? void 0 : stats.time.m) !== null && _d !== void 0 ? _d : 0).padStart(2, "0"),
                            react_1.default.createElement("small", null, "m"),
                            " ",
                            String((_e = stats === null || stats === void 0 ? void 0 : stats.time.s) !== null && _e !== void 0 ? _e : 0).padStart(2, "0"),
                            react_1.default.createElement("small", null, "s"),
                            " ",
                            react_1.default.createElement("sup", null,
                                react_1.default.createElement("small", null, "total"))),
                        react_1.default.createElement("li", null, (_f = stats === null || stats === void 0 ? void 0 : stats.browser.h) !== null && _f !== void 0 ? _f : 0,
                            react_1.default.createElement("small", null, "h"),
                            " ",
                            String((_g = stats === null || stats === void 0 ? void 0 : stats.browser.m) !== null && _g !== void 0 ? _g : 0).padStart(2, "0"),
                            react_1.default.createElement("small", null, "m"),
                            " ",
                            String((_h = stats === null || stats === void 0 ? void 0 : stats.browser.s) !== null && _h !== void 0 ? _h : 0).padStart(2, "0"),
                            react_1.default.createElement("small", null, "s"),
                            " ",
                            react_1.default.createElement("sup", null,
                                react_1.default.createElement("small", null, "browser"))))),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("div", null, t("Script executions")),
                    react_1.default.createElement("ul", null,
                        react_1.default.createElement("li", null, (_j = stats === null || stats === void 0 ? void 0 : stats.runs) !== null && _j !== void 0 ? _j : 0,
                            " ",
                            react_1.default.createElement("sup", null, "runs")),
                        react_1.default.createElement("li", null,
                            react_1.default.createElement("small", null, "avg"),
                            " ", (_k = stats === null || stats === void 0 ? void 0 : stats.time.avg_m) !== null && _k !== void 0 ? _k : 0,
                            react_1.default.createElement("small", null, "m"),
                            " ",
                            String((_l = stats === null || stats === void 0 ? void 0 : stats.time.avg_s) !== null && _l !== void 0 ? _l : 0).padStart(2, "0"),
                            react_1.default.createElement("small", null, "s"),
                            " ",
                            react_1.default.createElement("sup", null, "pr. run"))))))) : react_1.default.createElement(react_1.default.Fragment, null, "Loading")));
};
exports.default = IntegrationStatsList;
